// Ids
export const phoneTypeNameForShortCode: string = 'Short Code';
// Regex
export const shortCodeNumberRegEx = /^(?!1)\d{5,6}$/;
